import { render, staticRenderFns } from "./PromoProduct.vue?vue&type=template&id=0e01270e"
import script from "./PromoProduct.vue?vue&type=script&lang=js"
export * from "./PromoProduct.vue?vue&type=script&lang=js"
import style0 from "./PromoProduct.vue?vue&type=style&index=0&id=0e01270e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports